// extracted by mini-css-extract-plugin
export default {"root":"BackButton_root__C5Noo","navLink":"BackButton_navLink__jUepE","text":"BackButton_text__t3NC0"};